<!-- views/GitHubCallbackView.vue -->
<template>
  <div class="container-flex">
    <div class="d-flex justify-content-center align-items-center m-3">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg"
        alt="GitHub Logo"
        class="spinning-logo"
      />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/authStore';
import { getPKCE } from '@/utils/pkce';
import { ApiEndpoint, defaultPage } from '@/utils/config';

const auth = useAuthStore();
const router = useRouter();

const authenticateAndRedirect = async() => {
  const code = new URLSearchParams(window.location.search).get('code');
  const verifier = getPKCE();
  if (!code || !verifier) {
      console.error(`Missing OAuth code or PKCE verifier`);
      router.push({ name: 'Login' });
  }
  try {
    const authRes  = await fetch(ApiEndpoint.TOKEN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        provider: 'github',
        token: code,
        verifier: verifier,
        redirectUri: `${window.location.origin}/github-callback`,
      }),
    });
    const authInfo = await authRes.json();
    if (!authRes.ok || !authInfo.token) {
      throw new Error(`Failed to obtain token`);
    }
    auth.login(authInfo);
    router.push({ name: defaultPage });
  } catch(err) {
      console.error(`GitHub OAuth failed: ${err.message}`);
  }
}

onMounted(authenticateAndRedirect);

</script>

<style scoped>
@keyframes spin {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
.spinning-logo {
  width: 80px;
  height: 80px;
  animation-name: spin;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}
</style>